// extracted by mini-css-extract-plugin
export default {"videoWrapper":"styles_videoWrapper__XF4-P","qrVideo":"styles_qrVideo__E4q6O"};